import axios from "axios";
import { base_url } from "./ApiConst";
import { Token } from "./Token";
import {
  Add_To_Cart,
  Update_Cart,
  Remove_From_Cart,
  View_Cart,
  applyCoupon,
  Order_list,
  Sort_Order_list,
  COD_Payment,
  Past_Orders,
  Search_Past_Orders,
  Cancel_Order,
  View_Past_Orders,
  fetchCancellationReasons,
  fetchOrderCancellationReasons,
  cancelLineItem,
  fetchSellerCancellationReasons,
  sellerCancelLineItem,
  getProductAvailability,
  BuyAgainProducts,
  Search_Store_Orders,
  Search_Store_Orders_Suggestions,
  Cart_OrderId,
  Delivery_Method,
  fetchOrderDetailsStatus,
  getOrderDetails,
  Estimate_Cost,
} from "./apis/orderApi";
import { User_LogIn, login_OTP } from "./apis/loginApi";
import { categories, Sub_categories } from "./apis/categoryApi";
// import { Nearest_Shops } from "./apis/shopsApi";
import {
  Product_list,
  Search_Products,
  Product_Details,
  Single_Product_Details,
  getOutOfStockProductList,
  Product_Delete,
  All_Product_List,
  Sort_Product_List,
  Add_Bulk_Upload,
  Master_Product,
  Brought_Together,
  Unit_Of_Measure,
  Product_Ratings,
  Product_Details_Rating,
  User_Product_Rating,
  Store_Ratings,
  User_Last_Viewed,
  Store_Product_Details,
  Search_Store_Product,
  Search_Store_Product_Suggestions,
  Add_Product,
  Edit_Product,
  Products_for_Review,
  Last_Viewed,
} from "./apis/productsApi";
import {
  getNotifications,
  getAllNotifications,
  markNotificationAsRead,
} from "./apis/notificationsApi";
import { Top_Deals, Top_Deals_Suggestions } from "./apis/dealsApi";
import {
  Add_To_Wishlist,
  View_Wishlist,
  Delete_Wishlist,
} from "./apis/wishListApi";
import {
  Search_Stores,
  Store_Registration,
  Store_BankDetails,
  Store_View,
  Store_SubCategory_View,
  Set_Store,
  Store_Update,
  My_Store,
  Create_Offers,
  Edit_Offer,
  Offers_List,
  Store_offers,
  getOfferDetails,
  Store_Revenue,
  Store_Dashboard_Summary,
  Todays_Offers,
  Coupons,
  GET_BANK_DETAILS,
  Get_Store_Ratings,
  Selected_Store_Rating,
  User_Store_Rating,
  getStoreAccountStatement,
  getStoreAccountStatementPdf,
  getStoreTransactionData,
} from "./apis/storeApi";
import {
  Edit_User_Details,
  Get_User_Details,
  verifyEmail,
  OTP_TO_VERIFY_EMAIL,
  Saved_Address,
  Add_Address,
  Delete_Address,
  Edit_Address,
  UserProfile_Delete,
  Submit_Contact_Enquiry,
} from "./apis/usersApi";
import {
  Languages,
  All_Subcategories,
  subcategories,
  Payment_Status,
  getDetailedLocationWithLatandLong,
} from "./apis/miscellanousApi";

import {
  GetDeliveryPartners,
  GetDeliveryStats,
  GetStorePreference,
  UpdateStorePreference,
  SyncIntegratedOrders,
  GetMerchantDashboard,
  GetOrderStatus,
  RetryOrderSync,
  CheckServiceability,
  CheckCheckoutShipping,
  GetSettlementSummary,
  GetSettlementLedger,
} from "./apis/deliveryApi";

export const Nearest_Shops = async (payload) => {
  return await axios.post(
    `${base_url}/api/v0/dashboard/category/store_list/`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: Token,
      },
    }
  );
};

export {
  GetDeliveryPartners,
  GetDeliveryStats,
  GetStorePreference,
  UpdateStorePreference,
  SyncIntegratedOrders,
  GetMerchantDashboard,
  GetOrderStatus,
  RetryOrderSync,
  CheckServiceability,
  CheckCheckoutShipping,
  GetSettlementSummary,
  GetSettlementLedger,
};

export {
  Languages,
  All_Subcategories,
  subcategories,
  Payment_Status,
  getDetailedLocationWithLatandLong,
};
export {
  Edit_User_Details,
  Get_User_Details,
  verifyEmail,
  OTP_TO_VERIFY_EMAIL,
  Saved_Address,
  Add_Address,
  Delete_Address,
  Edit_Address,
  UserProfile_Delete,
  Submit_Contact_Enquiry,
};
export {
  Add_To_Cart,
  Update_Cart,
  Remove_From_Cart,
  View_Cart,
  applyCoupon,
  Order_list,
  Sort_Order_list,
  COD_Payment,
  Past_Orders,
  Search_Past_Orders,
  Cancel_Order,
  View_Past_Orders,
  fetchCancellationReasons,
  fetchOrderCancellationReasons,
  cancelLineItem,
  fetchSellerCancellationReasons,
  sellerCancelLineItem,
  getProductAvailability,
  BuyAgainProducts,
  Search_Store_Orders,
  Search_Store_Orders_Suggestions,
  Cart_OrderId,
  Delivery_Method,
  fetchOrderDetailsStatus,
  getOrderDetails,
  Estimate_Cost,
};
export {
  Search_Stores,
  Store_Registration,
  Store_BankDetails,
  Store_View,
  Store_SubCategory_View,
  Set_Store,
  Store_Update,
  My_Store,
  Create_Offers,
  Edit_Offer,
  Offers_List,
  Store_offers,
  getOfferDetails,
  Store_Revenue,
  Store_Dashboard_Summary,
  Todays_Offers,
  Coupons,
  GET_BANK_DETAILS,
  Get_Store_Ratings,
  Selected_Store_Rating,
  User_Store_Rating,
  getStoreAccountStatement,
  getStoreAccountStatementPdf,
  getStoreTransactionData,
};
export { Add_To_Wishlist, View_Wishlist, Delete_Wishlist };
export { User_LogIn, login_OTP };
export { categories, Sub_categories };
// export { Nearest_Shops };
export {
  Product_list,
  Search_Products,
  Product_Details,
  Single_Product_Details,
  getOutOfStockProductList,
  Product_Delete,
  All_Product_List,
  Sort_Product_List,
  Add_Bulk_Upload,
  Master_Product,
  Brought_Together,
  Unit_Of_Measure,
  Product_Ratings,
  Product_Details_Rating,
  User_Product_Rating,
  Store_Ratings,
  User_Last_Viewed,
  Store_Product_Details,
  Search_Store_Product,
  Search_Store_Product_Suggestions,
  Add_Product,
  Edit_Product,
  Products_for_Review,
  Last_Viewed,
};
export { getNotifications, getAllNotifications, markNotificationAsRead };
export { Top_Deals, Top_Deals_Suggestions };
// export const Submit_Cart = async (storeId, selectedSubcategory) => {
//   // const token = "9i8h7g6f-5e4d-3c2b-1a0j-dcba098765fe";
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

//   let params = {
//     currency: "NPR",
//     code: "",
//     order_id: 34,
//     submit: "",

//     submit: "True",
//     first_name: "",
//     last_name: "",
//     email: "",
//     mobile_number: "",
//     address: "",
//     city: "",
//     pincode: "",
//     country: "",
//     state: "",
//     payment_gateway: "",
//     gateway_data: {},
//     success_val:
//       "Current False to reject else True for success check to create a Transaction",
//   };

//   const response = await axios.post(`${base_url}api/v0/orders/cart/`, params, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: userToken1 ? `Token ${userToken1}` : Token,
//     },
//   });
//   return response;
// };

// export const Get_Bulk_Upload = async (userToken) => {
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
//   try {
//     const response = await axios.get(
//       `${base_url}api/v0/store/product/bulk_upload/`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: "Token " + userToken1,
//         },
//       }
//     );
//     return response;
//   } catch (error) {
//     throw new Error(error);
//   }
// };

// export const Payment_Status = async (uuid) => {
//   let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
//   // console.log("USER_TPKRN", userToken1);
//   let enc_code = window.location.href;
//   // console.log("enc_CODEREEEE", enc_code);
//   const data = enc_code.split("data=")[enc_code.split("data=").length - 1];
//   // let userToken1 = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
//   let success = true ? data.includes("confirm-order") : false;
//   let check_url = success
//     ? `${base_url}payments/initiate/khalti/${
//         uuid.split("uuid=")[1].split("&")[0]
//       }/`
//     : `${base_url}payments/initiate/khalti/${
//         uuid.split("uuid=")[1].split("&")[0]
//       }/?data=${data}`;
//   // console.log("ENCCCCCCCCCC SPLIT", enc_code.split('data=')[enc_code.split('data=').length - 1])
//   return await axios.get(check_url, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Token ${userToken1}`,
//     },
//   });
// };

// User Cancel Line Item

// Seller Cancel Line Item

// Fetch Order Details Status for seller

// API for cancel line item of order for seller.

// Check Product Availablity

// export const markNotificationAsRead = async (notificationId) => {
//   try {
//     const response = await axiosInstance.put(
//       `api/v0/auth/user/notification/details/${notificationId}/`,
//       {},
//       {
//         useUserToken: true,
//         maxBodyLength: Infinity,
//       }
//     );
//     return response.data; // Response after updating the notification
//   } catch (error) {
//     console.error("Error updating notification status:", error);
//     throw error;
//   }
// };
